import styles from './SetRunningData.module.css'
import {LGBTButton} from "../../components/lgbtButton/LGBTButton";
import {InputBottomPlaceholder} from "../../components/inputBottomPlaceholder/InputBottomPlaceholder";
import {UploadFileUI} from "../../components/upload/UploadFileUI";
import {Modal} from "../../components/modal/Modal";
import {MakeMoneyTransfer} from "../MakeMoneyTransfer/MakeMoneyTransfer";
import {useState} from "react";
import {useAppDispatch, useAppSelector} from '../../hooks/redux';
import {ActivityType, filesImage, ImagesDomain} from '../../models/commonModels';
import {activityUser, fetchError} from '../../store/app-slice/AppSlice';
import {useNavigate} from 'react-router-dom';
import {format} from 'date-fns';
import {GetProp, UploadFile, UploadProps } from 'antd';
import { ActivityBar } from '../../components/ActivityBar/ActivityBar';
export const SetRunningData = ()=>{
    const dispatch:any = useAppDispatch();
    const [km,setKm] = useState(0);
    const [h,setH] = useState(0);
    const [m,setM] = useState(0);
    const [isOpen,setIsopen] = useState(false)
    const [uploadFiles,setUploadFiles] = useState<filesImage[]>([]);
    const [uploadBlob, setUploadBlob] = useState<UploadFile<any>[]> ([])
    const navigation = useNavigate();
    const token = useAppSelector(state=>state.appStore.token)
    type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
    const activity = useAppSelector(state=>state.appStore.activity_type)
    async function saveResult (){
        
        if(token==null){
            navigation("*");
            return};
        if(uploadFiles.length==0){
            dispatch(fetchError("Не загружено фото!!!"))
            setTimeout(function(){dispatch(fetchError(null))}, 3000); 
            return;
        }

        const currentDate: Date = new Date();
        const formattedDate: string = format(currentDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
        var images:ImagesDomain[] = [];
        uploadFiles.forEach((file)=>{
            images.push({image:file.fDataBase64,file_name:file.fName})
        })
        if(activity!=null){
            const isLoad:boolean = await dispatch(activityUser(token.token,km,"",formattedDate,uploadFiles[0].fDataBase64,uploadBlob[0].originFileObj as FileType, h, m,images,activity))
            if(isLoad)setIsopen(true)
        }
    }

    const isLargeM = () =>{
        return activity==ActivityType.SWIMMING||activity==ActivityType.SWIMMING_185||activity==ActivityType.WALK
    }


    return (
        <div className={styles.running_data_content}>
            <ActivityBar/>
            <div className={styles.running_data_title}>Ваш сегодняшний результат</div>
            <div className={styles.running_data_result_content}>
                <InputBottomPlaceholder placeholder={activity===ActivityType.SWIMMING||activity===ActivityType.SWIMMING_185?"метров":"километров"} 
                    max={isLargeM()?100000:9999} 
                    onChangeValue={value=>setKm(value)} 
                    isDecimal={true} 
                    fontSize={isLargeM()?25:32} 
                    width={105}/>
                <InputBottomPlaceholder placeholder={"часов"} max={23} onChangeValue={value=>setH(value)}/>
                <InputBottomPlaceholder placeholder={"минут"} max={59} onChangeValue={value=>setM(value)}/>
            </div>
            <UploadFileUI onFilesChange={setUploadFiles} onUploadFileChange={setUploadBlob}/>
            {km>0&&<LGBTButton onClick={saveResult} text={"Сохранить результат"}/>}
            {km===0&&<LGBTButton onClick={()=>{}} text={"Сохранить результат"} colors={["gray","gray"]}/>}
            <Modal isOpen={isOpen}>
                <Modal.Content isClosable={true} onClose={()=>{setIsopen(false);navigation("*")}}>
                    <MakeMoneyTransfer onClose={()=>{setIsopen(false)}}/>
                </Modal.Content>
            </Modal>
        </div>
    )
}